import { render } from "./HomeJYWZ.vue?vue&type=template&id=9fa7562e&scoped=true"
import script from "./HomeJYWZ.vue?vue&type=script&lang=js"
export * from "./HomeJYWZ.vue?vue&type=script&lang=js"

import "./HomeJYWZ.vue?vue&type=style&index=0&id=9fa7562e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa7562e"]])

export default __exports__